export {};
/*!
 * jQuery Browser detection plugin v1.0.0
 * jQuery plugin for browser detection 
 *
 * https://github.com/danieledesantis/jquery-browser-detection
 *
 * Released under the MIT License
 * Copyright 2015 Daniele De Santis
 */
(function ($) {

	$.extend({
		browserDetection: function (type) {

			var theHtml = $('html'),
				userAgent = window.navigator.userAgent,
				msieIndex = userAgent.indexOf('MSIE '),
				edgeIndex = userAgent.indexOf('Edge'),
				currentBrowserVersion,
				currentBrowser,
				browserClass,
				returnValue;

			if (msieIndex != -1) { // IE <= 10
				var ieVersion = userAgent.substring(msieIndex + 5, userAgent.indexOf('.', msieIndex)); // IE version
				currentBrowser = 'ie';
				currentBrowserVersion = currentBrowser + ieVersion;
				browserClass = currentBrowser + ' ' + currentBrowser + currentBrowserVersion;
				switch (ieVersion) {
					case '9':
						browserClass += ' lt-ie10';
						break;
					case '8':
						browserClass += ' lt-ie9';
						break;
					case '7':
						browserClass += ' lt-ie9 lt-ie8';
						break;
					case '6':
						browserClass += ' lt-ie9 lt-ie8 lt-ie7';
						break;
					default:
						break;
				}
			} else if (userAgent.indexOf('Trident/') != -1) { // IE11
				currentBrowser = 'ie';
				currentBrowserVersion = currentBrowser + '11';
				browserClass = currentBrowser + ' ' + currentBrowserVersion;
			} else if (edgeIndex != -1) {
				var edgeVersion = userAgent.substring(edgeIndex + 5, userAgent.indexOf('.', edgeIndex)); // Edge version
				currentBrowser = 'edge';
				currentBrowserVersion = currentBrowser + edgeVersion;
				browserClass = currentBrowser + ' ' + currentBrowserVersion;
			} else if (userAgent.indexOf('Chrome') != -1) {
				if (userAgent.indexOf('OPR') != -1) { // Opera
					currentBrowserVersion = browserClass = 'opera';
				} else { // Chrome
					currentBrowser = 'chrome';
					currentBrowserVersion = userAgent.substring(userAgent.indexOf('Chrome') + 7, userAgent.indexOf('.', userAgent.indexOf('Chrome')));
					browserClass = currentBrowser + ' ' + currentBrowser + currentBrowserVersion;
				}
				browserClass += ' no-ie';
			} else if (userAgent.indexOf('Safari') != -1 && userAgent.indexOf('Chrome') == -1) { // Safari
				currentBrowserVersion = browserClass = 'safari';
				browserClass += ' no-ie';
			} else if (userAgent.indexOf('Firefox') != -1) { // Firefox
				currentBrowser = 'firefox';
				currentBrowserVersion = userAgent.substring(userAgent.indexOf('Firefox') + 8, userAgent.indexOf('.', userAgent.indexOf('Firefox')));
				browserClass = currentBrowser + ' ' + currentBrowser + currentBrowserVersion;
				browserClass += ' no-ie';
			} else {
				currentBrowserVersion = 'notDetected';
				browserClass = '';
			}

			switch (type) {
				case 'addClass':
					theHtml.addClass(browserClass);
					break;
				case 'version':
					returnValue = currentBrowserVersion;
					break;
				default:
					returnValue = currentBrowser;
					break;
			}

			return returnValue;
		},
	});

}(jQuery));